<template>
  <v-container pa-2>
    <v-layout justify-center column>
      <v-card class="mt-2 pb-0" style="border-radius: 5px">
        <!-- Toolbar -->
        <v-toolbar dense flat id="toolbar">
          <v-layout
            row
            id="layoutToolbar"
            :style="[
              this.$i2kFunctions.isSmartphone()
                ? {
                    'margin-right': '0px',
                    'margin-left': '0px',
                    'padding-right': '0px',
                    'padding-left': '0px',
                  }
                : {},
            ]"
          >
            <!-- pulsante indietro -->
            <span
              id="pulsanteIndietro"
              :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']"
            >
              <v-tooltip v-if="getPagePreve == '/preventivo'" top>
                <v-btn slot="activator" icon v-on:click="prevPage">
                  <v-icon>navigate_before</v-icon>
                </v-btn>
                Indietro
              </v-tooltip>
            </span>

            <v-spacer></v-spacer>
            <span id="titoloPreventivatore">
              {{ this.$i2kFunctions.isSmartphone() ? "" : "PREVENTIVATORE - " }}
              Collezione SPEEDY
            </span>
            <v-spacer></v-spacer>
            <div id="containerPulsanti">
              <!-- Stampa -->
              <span
                :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']"
              >
                <v-tooltip v-if="getPagePreve == '/preventivo'" top>
                  <v-btn slot="activator" icon flat v-on:click="stampaOrdine()">
                    <v-icon>print</v-icon>
                  </v-btn>
                  Stampa
                </v-tooltip>
              </span>

              <!-- Ricarica Dati -->
              <span
                :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']"
              >
                <v-tooltip top>
                  <v-btn slot="activator" icon @click="refresh()">
                    <v-icon>refresh</v-icon>
                  </v-btn>
                  <span>Ricarica dati</span>
                </v-tooltip>
              </span>

              <!-- Impostazioni -->
              <span
                :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']"
              >
                <v-menu
                  ref="menuOpen"
                  v-model="menuOpen"
                  bottom
                  left
                  offset-x
                  :close-on-content-click="false"
                >
                  <v-btn slot="activator" icon flat @click="GetMaggiorazioni()">
                    <v-icon>settings</v-icon>
                  </v-btn>

                  <v-card class="mx-auto" width="180px">
                    <v-menu bottom offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          style="border-radius: 5px"
                        >
                          <v-icon>keyboard_arrow_down</v-icon>
                          Maggiorazioni
                        </v-btn>
                      </template>

                      <v-list class="list" dense>
                        <v-list-tile class="tile">
                          <v-list-tile-title class="titolo">
                            Magg. Netta
                          </v-list-tile-title>
                          <v-list-tile-content class="content">
                            <v-text-field
                              style="width: 100%"
                              v-model="maggiorazioni.MaggNetta"
                            >
                            </v-text-field>
                          </v-list-tile-content>
                          <v-list-tile-action class="action">
                            €
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-list-tile class="tile">
                          <v-list-tile-title class="titolo">
                            Magg. Perc
                          </v-list-tile-title>
                          <v-list-tile-content class="content">
                            <v-text-field v-model="maggiorazioni.MaggPerc">
                            </v-text-field>
                          </v-list-tile-content>
                          <v-list-tile-action class="action">
                            %
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-list-tile class="tile">
                          <v-list-tile-title class="titolo">
                            Sconto
                          </v-list-tile-title>
                          <v-list-tile-content class="content">
                            <v-text-field v-model="maggiorazioni.Sconto">
                            </v-text-field>
                          </v-list-tile-content>
                          <v-list-tile-action class="action">
                            %
                          </v-list-tile-action>
                        </v-list-tile>
                        <v-divider></v-divider>

                        <v-btn
                          color="#ECCD20"
                          @click="SalvaMaggiorazioni()"
                          v-on:click="menuOpen = false"
                        >
                          Salva
                        </v-btn>
                      </v-list>
                    </v-menu>
                    <v-btn
                      v-if="
                        getPagePreve == '/preventivo' &&
                        this.$i2kFunctions.isSmartphone()
                      "
                      style="
                        border-radius: 5px;
                        width: 92%;
                        font-size: 90%;
                        padding-left: 0px;
                        padding-right: 0px;
                      "
                      v-on:click="eliminaPreventivo()"
                    >
                      <v-icon> delete </v-icon>
                      Elimina preventivo
                    </v-btn>
                    <v-btn
                      style="
                        border-radius: 5px;
                        width: 92%;
                        padding-left: 0px;
                        padding-right: 0px;
                      "
                      @click="caricaFile()"
                      v-on:click="menuOpen = false"
                    >
                      <v-icon> cloud_upload </v-icon>
                      Carica file
                    </v-btn>
                    <v-btn
                      style="
                        border-radius: 5px;
                        width: 92%;
                        padding-left: 0px;
                        padding-right: 0px;
                      "
                      @click="ricaricaPagina()"
                      v-on:click="menuOpen = false"
                    >
                      <v-icon> refresh </v-icon>
                      Ricarica pagina
                    </v-btn>
                  </v-card>
                </v-menu>
              </span>
            </div>
          </v-layout>
        </v-toolbar>
      </v-card>
    </v-layout>

    <FilePreventivi
      :dialog="dialogUpload"
      @chiudiDialogFile="chiudiDialogFile"
    ></FilePreventivi>
  </v-container>
</template>

<script>
import FilePreventivi from "@/components/dialog/preventivi/FilePreventivi.vue";

import {
  stampa_Preventivo,
  set_maggiorazioni,
  get_maggiorazioni,
  del_preventivo,
} from "@/api/api.preventivi.js";

export default {
  components: {
    FilePreventivi,
  },

  data: () => ({
    currentPage: "",
    maggiorazioni: {
      MaggNetta: 0,
      MaggPerc: 0,
      Sconto: 0,
    },

    menuOpen: false,

    dialogUpload: false,
  }),

  methods: {
    prevPage() {
      this.$router.push({
        path: "/preventivi",
      });
    },

    async SalvaMaggiorazioni() {
      let user = await this.$store.dispatch("user/userInfo");
      let par = {};
      if (this.$store.getters["app/getPagePreve"] == "/preventivi")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: -1,
          Sconto: this.maggiorazioni.Sconto,
          MaggPerc: this.maggiorazioni.MaggPerc,
          MaggNetta: this.maggiorazioni.MaggNetta,
        };
      else if (this.$store.getters["app/getPagePreve"] == "/preventivo")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: this.getNumPreve(),
          Sconto: this.maggiorazioni.Sconto,
          MaggPerc: this.maggiorazioni.MaggPerc,
          MaggNetta: this.maggiorazioni.MaggNetta,
        };
      let res = await set_maggiorazioni(par);
      if (res.data == "OK") {
        this.$toast.info("Maggiorazioni salvate");
        this.refresh();
      } else this.$toast.warning("Impossibile salvare le maggiorazioni");
    },

    async GetMaggiorazioni() {
      let user = await this.$store.dispatch("user/userInfo");
      let par = {};
      if (this.$store.getters["app/getPagePreve"] == "/preventivi")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: -1,
        };
      else if (this.$store.getters["app/getPagePreve"] == "/preventivo")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: this.getNumPreve(),
        };
      else return;
      let res = await get_maggiorazioni(par);
      this.maggiorazioni = res.data;
    },

    async stampaOrdine() {
      let res = await stampa_Preventivo(this.getNumPreve());
      this.$i2kFunctions.createBlobPdf(res.data);
    },

    getNumPreve() {
      return this.$store.getters["app/getNumPreve"];
    },

    async eliminaPreventivo() {
      let confirm = await this.$root.$confirm(
        "Elimina",
        "Attenzione! Questa operazione eliminerà tutti i dati del preventivo corrente. Vuoi continuare?"
      );
      if (!confirm) return;
      // Attesa
      this.$root.$wait.open();
      let res = await del_preventivo(this.getNumPreve());
      // Pulizia
      if (res.data == "OK") {
        this.$toast.warning("Preventivo eliminato");
      }
      this.$root.$wait.close();
      this.$router.push({ path: "/preventivi" });
    },

    refresh() {
      this.$store.commit("app/SET_REFRESHDATI", true);
    },

    ricaricaPagina() {
      window.location.reload();
    },

    caricaFile() {
      this.$root.$wait.open();
      this.dialogUpload = true;
      this.$root.$wait.close();
    },

    chiudiDialogFile() {
      this.dialogUpload = false;
    },
  },

  mounted() {
    this.GetMaggiorazioni();
  },

  computed: {
    getPagePreve: function () {
      return this.$store.getters["app/getPagePreve"];
    },

    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },

  watch: {
    $route(to, from) {
      //serve per capire da che pagina parto a che pagina arrivo
      this.$store.commit("app/SET_PAGEPREVE", to.path);
      this.GetMaggiorazioni();
    },

    userSwitch() {
      this.GetMaggiorazioni();
    },
  },
};
</script>

<style scoped src= "../../assets/styles/preventivo.css">
</style>